import { Storage } from '@intelipost-js/secure-providers';

const PageOccurrencesValidation = () => import('./PageOccurrencesValidation');
const originMenu = Storage.get('originMenu', 'local') || 'oldmenu';
const pageTitle = originMenu === 'newmenu' ? 'Validação do Arquivo de Ocoren' : 'Validar arquivo de ocorrência';

export default {
  path: 'occurrences-validation',
  name: 'settings-occurrences-validation',
  component: PageOccurrencesValidation,
  meta: {
    title: pageTitle,
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/occurrences-validation/routes.js